import React from 'react'
import { DiGithubBadge } from "react-icons/di";
import { BsLinkedin } from "react-icons/bs";
import { Link } from 'react-router-dom';
function Deployment() {

const [title , settitle] = React.useState();
const [subject ,setsubject]= React.useState();
const [img ,setimg]= React.useState();

function handlex()
{
    settitle("Developer Weekly");
    setimg("aave.png");
    setsubject(" Create Application or solve some bugs from developers weekly page within the given deadline  ")
}

function handley()
{
    settitle("Contribute In Frame-Works-docs ");
    setimg("laravel.png");
    setsubject(" Add some new snippets and their role to our framworks docs  visit Frameworks Sections for more ideas")
}
function handlez()
{
    settitle("Solve Complete Hack-Map (Striver  Raj-Vikramadaitya Sheet) ");
    setimg("leetcode.png");
    setsubject(" Solve Complete Striver sheet and make a github repo of each problem and submit in Hack-DSA Console")
}

function handlea()
{
    settitle("Get Rewards ");
    setimg("trophy.png");
    setsubject("Once you are shortlisted by our community you will get mail for getting rewards from us ❤️")
}





  return (
   <>
   <div className='deploycontainer'>
    <h1 className='head hover:text-red-900'>Data-Structures <span className='text-blue-900'>X  </span>
       Development</h1>
       <section className="text-gray-600 body-font">
  <div className="container mx-auto flex px-5 py-0 md:flex-row flex-col items-center">
    <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
      <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-gray-900">
      Software Development
        <br className="hidden lg:inline-block" />
    Frameworks 🚀
      </h1>
      <p className="mb-8 leading-relaxed">
      A framework is a platform that you can use to build applications. It provides the foundation for developers to create their software as it necessarily imposes an architectural paradigm and even includes a development philosophy. You might not care for anything that imposes you something but in the case of frameworks, that imposition is a huge advantage. 
      </p>
      <div className="flex justify-center">
      <a href="#_" class="relative inline-flex items-center justify-start px-6 py-3 overflow-hidden font-medium transition-all bg-blue-500 rounded-xl group">
<span class="absolute top-0 right-0 inline-block w-4 h-4 transition-all duration-500 ease-in-out bg-blue-700 rounded group-hover:-mr-4 group-hover:-mt-4">
<span class="absolute top-0 right-0 w-5 h-5 rotate-45 translate-x-1/2 -translate-y-1/2 bg-white"></span>
</span>
<span class="absolute bottom-0 left-0 w-full h-full transition-all duration-500 ease-in-out delay-200 -translate-x-full translate-y-full bg-blue-600 rounded-2xl group-hover:mb-12 group-hover:translate-x-0"></span>
<span class="relative w-full text-left text-white transition-colors duration-200 ease-in-out group-hover:text-white">View Frameworks</span>
</a>
      </div>
    </div>
    <div className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6">
      <img
        className="object-cover object-center rounded"
        alt="hero"
        src="css3.png"
      />
    </div>
  </div>
</section>

<section className="text-gray-600 body-font">
  <div className="container mx-auto flex px-5 py-0 md:flex-row flex-col items-center">
    <div className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6 mb-10 md:mb-0">
      <img
        className="object-cover object-center rounded"
        alt="hero"
        src="keyboard.png"
      />
    </div>
    <div className="lg:flex-grow md:w-1/2 lg:pl-24 md:pl-16 flex flex-col md:items-start md:text-left items-center text-center">
      <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-gray-900">
       Data-Structures
      </h1>
      <p className="mb-8 leading-relaxed">
      Data Structures teach you how computer stores the data in memory so that it can be retrieved, updated, stored in a faster manner. A coding problem that is solvable using Polynomial Time without using appropriate data structure, can be solved in linear time it data is stored in an appropriate data structure.

That’s the reason data structures and algorithms are MUST for having an upper hand in coding interviews of top MNCs like Microsoft, Google, Amazon, Facebook…
      </p>
      <a href="#_" class="relative rounded px-5 py-2.5 overflow-hidden group bg-blue-500 relative hover:bg-gradient-to-r hover:from-blue-500 hover:to-blue-400 text-white hover:ring-2 hover:ring-offset-2 hover:ring-blue-400 transition-all ease-out duration-300">
<span class="absolute right-0 w-8 h-32 -mt-12 transition-all duration-1000 transform translate-x-12 bg-white opacity-10 rotate-12 group-hover:-translate-x-40 ease"></span>
<span class="relative">Challenges</span>
</a>
    
    
    </div>
  </div>
</section>

   </div>
   <h1 className='head ml-70'>How to Win <span className='text-blue-900'>Rewards </span>
        from HackScript ❤️</h1>
   <section className="text-gray-600 body-font">
  <div className="container px-5 py-24 mx-auto flex flex-wrap flex-col">
    <div className="flex mx-auto flex-wrap mb-20">
      <a className="sm:px-6 py-3 w-1/2 sm:w-auto justify-center sm:justify-start border-b-2 title-font font-medium  inline-flex items-center leading-none hover:border-indigo-500 hover:text-indigo-500 tracking-wider rounded-t"  onClick={handlex}>
        <svg
       
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          className="w-5 h-5 mr-3"
          viewBox="0 0 24 24"
        >
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        </svg>
        STEP 1
      </a>
      <a className="sm:px-6 py-3 w-1/2 sm:w-auto justify-center sm:justify-start border-b-2 title-font font-medium inline-flex items-center leading-none  hover:border-indigo-500 hover:text-indigo-500   border-gray-200 hover:text-gray-900 tracking-wider" onClick={handley}>
        <svg
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          className="w-5 h-5 mr-3"
          viewBox="0 0 24 24"
        >
          <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
        </svg>
        STEP 2
      </a>
      <a className="sm:px-6 py-3 w-1/2 sm:w-auto justify-center sm:justify-start border-b-2 title-font font-medium inline-flex items-center leading-none  hover:border-indigo-500 hover:text-indigo-500  border-gray-200 hover:text-gray-900 tracking-wider" onClick={handlez}>
        <svg
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          className="w-5 h-5 mr-3"
          viewBox="0 0 24 24"
        >
          <circle cx={12} cy={5} r={3} />
          <path d="M12 22V8M5 12H2a10 10 0 0020 0h-3" />
        </svg>
        STEP 3
      </a>
      <a className="sm:px-6 py-3 w-1/2 sm:w-auto justify-center sm:justify-start border-b-2 title-font font-medium inline-flex items-center leading-none hover:border-indigo-500 hover:text-indigo-500  border-gray-200 hover:text-gray-900 tracking-wider" onClick={handlea}>
        <svg
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          className="w-5 h-5 mr-3"
          viewBox="0 0 24 24"
        >
          <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" />
          <circle cx={12} cy={7} r={4} />
        </svg>
        STEP 4
      </a>
    </div>
    <img
      className="xl:w-1/4 lg:w-1/3 md:w-1/2 w-2/3 block mx-auto mb-10 object-cover object-center rounded"

      src={img}
    />
    <div className="flex flex-col text-center w-full">
      <h1 className="text-xl font-medium title-font mb-4 text-gray-900">
      {title}
      </h1>
      <p className="lg:w-2/3 mx-auto leading-relaxed text-base">
       {subject}
      </p>
    </div>
  </div>
</section>

<h1 className='head text-blue-700'>Follow us ..  ❤️ So we Get In Touch </h1>


<div className='flex flex-row'>
<p className="lg:w-2/3 margins leading-relaxed text-base flex flex-row">
<DiGithubBadge size={70}/>
<span className='ml-7 mt-4'> <BsLinkedin size={40} color ={"blue"}/></span>

      </p>

</div>


<footer className="text-gray-600 body-font bg-gray-100">
  <div className="container px-5 py-8 mx-auto flex items-center sm:flex-row flex-col">
    <a className="flex title-font font-medium items-center md:justify-start justify-center text-gray-900">
    <img src='hackscript.png' className='logoimg'></img>
      <span className="ml-3 text-xl">HackScripts</span>
    </a>
    <p className="text-sm text-gray-500 sm:ml-4 sm:pl-4 sm:border-l-2 sm:border-gray-200 sm:py-2 sm:mt-0 mt-4">
      ©2022—HackScript Community      
    </p>

    <Link to="/about"
        
        className="text-gray-600 ml-7 hover:text-red-900"
        rel="noopener noreferrer"
       
      >
        Team Members ⭐
      </Link>  
    
    <span className="inline-flex sm:ml-auto sm:mt-0 mt-4 justify-center sm:justify-start">
      <a className="ml-3 text-gray-500">
        <svg
          fill="currentColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0}
          className="w-5 h-5"
          viewBox="0 0 24 24"
        >
          <path
            stroke="none"
            d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"
          />
          <circle cx={4} cy={4} r={2} stroke="none" />
        </svg>
      </a>
    </span>
  </div>
</footer>


   </>
  )
}

export default Deployment